import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class LedgerSnapShotUseCase extends BaseUseCase {
    constructor(LedgerRepo) {
        super();
        this.LedgerRepo = LedgerRepo;
    }
    async fetchResult(req) {
        return await this.LedgerRepo.snapShotEntentionDetails(req);
    }
}
export default LedgerSnapShotUseCase;
